import { undefOrNull } from './objects';
import { getDefaultOptions } from 'date-fns';
export const camelizeKebabcase = (s) => s.replace(/-./g, (x) => x[1].toUpperCase());
export const capitalize = (s) => {
    if (undefOrNull(s))
        return '';
    if (isEmpty(s))
        return '';
    return s[0].toUpperCase() + s.slice(1);
};
export const toSnakeCase = (str) => {
    return str.replace(/\s+/g, '_').replace(/[A-Z]/g, '_$&').toLowerCase().replace(/^_/, '');
};
// Sorry for that
const excludedWord = ['de'];
export const capitalizeAll = (s) => {
    if (undefOrNull(s))
        return '';
    if (isEmpty(s))
        return '';
    let wordArray = s.split(' ');
    wordArray = wordArray.map((w) => (!excludedWord.some((w2) => w2 === w) ? capitalize(w) : w));
    return wordArray.join(' ');
};
export const removeWhiteSpace = (s) => {
    return s.replace(/\s/g, '');
};
export const isEmpty = (s) => {
    return !undefOrNull(s) && removeWhiteSpace(s).length === 0;
};
export const getFirstLetter = (s) => {
    return s?.length ? s[0] : '';
};
export const camelize = (s) => {
    return s?.replace(/^([A-Z])|[\s-_]+(\w)/g, (match, p1, p2) => {
        if (p2) {
            return p2.toUpperCase();
        }
        else {
            return p1.toLowerCase();
        }
    });
};
export const decamelize = (s, separator) => {
    separator = !separator ? '_' : separator;
    return s
        ? s
            .replace(/([a-z\d])([A-Z])/g, '$1' + separator + '$2')
            .replace(/([A-Z]+)([A-Z][a-z\d]+)/g, '$1' + separator + '$2')
            .toLowerCase()
        : '';
};
export const enumToCSSClass = (s) => {
    return s.replace(/_/g, '-').toLowerCase();
};
export const pathToEnum = (s) => {
    return s.replace(/-/g, '_').toUpperCase();
};
export const getParamsFromUrl = (url) => {
    const paramsObj = {};
    const queryString = url.split('?')[1];
    queryString &&
        queryString.split('&').forEach((param) => {
            const paramKey = param.split('=')[0];
            paramsObj[paramKey] = param.split('=')[1];
        });
    return paramsObj;
};
export const formatAmount = (amount) => {
    return formatNumberByOptions({ maximumSignificantDigits: 2 }).format(amount);
};
export const formatAmountWithCurrency = (amount, currency = 'EUR') => {
    const fractionDigits = Number.isInteger(amount) ? 0 : 2;
    return formatNumberByOptions({
        style: 'currency',
        currency: currency,
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits
    }).format(amount);
};
export const formatRateToPercentage = (rate) => {
    return formatNumberByOptions({
        style: 'percent',
        maximumSignificantDigits: 3
    }).format(rate);
};
export const formatNumberWithTwoDecimals = (n) => {
    return formatNumberByOptions({
        maximumFractionDigits: 2
    }).format(n);
};
export const formatToTwoDecimals = (number) => {
    return formatNumberByOptions({
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(number);
};
const formatNumberByOptions = (options) => {
    try {
        const locale = getDefaultOptions().locale;
        return new Intl.NumberFormat(locale?.code, options);
    }
    catch (error) {
        return new Intl.NumberFormat('fr-FR', options);
    }
};
export const enumToString = (s) => {
    return capitalize(s.split('_').join(' ').toLowerCase());
};
export const enumToDictionary = (s) => {
    return camelize(s.split('_').join(' ').toLowerCase());
};
export const rnToBr = (s) => {
    const rnReplaced = s.replaceAll('\r\n', '<br/>');
    const nrReplaced = rnReplaced.replaceAll('\n\r', '<br/>');
    const rReplaced = nrReplaced.replaceAll('\r', '<br/>');
    return rReplaced.replaceAll('\n', '<br/>');
};
export const commaToList = (s) => {
    return s.split(',');
};
export const semicolonToList = (s) => {
    return s.split(';');
};
export const cleanHTML = (s) => {
    return s.replace(/<[^>]*>?/gm, '');
};
export const formatHTML = (s) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    s = s.replace(urlRegex, function (url) {
        return '<a target="_blank" href="' + url + '">' + url + '</a>';
    });
    return rnToBr(s);
};
export const formatFrenchPhoneNumber = (s) => {
    let stringArray = s.split('+33');
    let areaCode = `+33 (0)${stringArray[1].slice(0, 1)}.`;
    let number = stringArray[1].substring(1).replace(/(.{2})/g, '$1.');
    return `${areaCode}${number.substring(0, number.length - 1)}`;
};
